import { cn } from "@/lib/utils"

/** Slim, always-visible notice that the whole environment runs on synthetic data. */
export function DemoBanner({ className }: { className?: string }) {
  return (
    <div
      role="note"
      title="All Corporation, Zilla Parishad, STP, flow, quality, reuse and water-gap figures in this environment are synthetic demonstration data, not live or official data."
      className={cn(
        "flex h-6 presentation:h-7 shrink-0 items-center justify-center gap-2 border-b border-amber-500/20 bg-amber-500/[0.06] px-3",
        "text-[11px] presentation:text-xs font-semibold uppercase tracking-[0.06em] sm:tracking-[0.14em] text-amber-800 dark:text-amber-300",
        className,
      )}
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500/80" aria-hidden />
      <span className="truncate">Demonstration environment — synthetic data</span>
    </div>
  )
}
